import styled from "styled-components";
import {HomepageHeaderArenaMenuItemDefaultBox} from "./home-page-header-arena-menu-item.default.box";
import {baseColors} from "../../../../../themes/definitions/mrgreen/base-colors";

export const HomepageHeaderArenaMenuItemMrGreenBox = styled(HomepageHeaderArenaMenuItemDefaultBox)`
  color: ${({theme}) => theme.colors.textContrast};
  &:hover {
    color: ${baseColors.white};
  }
`;
